/* eslint-disable max-classes-per-file */
import { selectorFromId } from 'features/common/utils';

export enum MapControlValue {
  true = 1,
  false = 0,
  disabled = 'disabled',
}

export class MapControl {
  // #map: any;
  #container: any;
  #widgetId: string;
  title?: string;
  initialValue?: MapControlValue;
  clickHandler?: (ev) => void;
  static TRUE_VALUE_CLASS = 'selected';
  static DISABLED_CLASS = 'disabled';

  constructor(
    widgetId: string,
    title?: string,
    initialValue?: boolean | MapControlValue,
    clickHandler?: (ev) => void,
  ) {
    this.#widgetId = widgetId;
    this.title = title;
    this.initialValue = MapControl.sanitiseValue(initialValue);

    this.clickHandler = clickHandler;
  }

  static sanitiseValue(value: boolean | MapControlValue): MapControlValue {
    if (value === true || value === undefined) {
      return MapControlValue.true;
    } else if (value === false) {
      return MapControlValue.false;
    } else {
      return value;
    }
  }

  static valueToClass(value: MapControlValue) {
    if (value === MapControlValue.true) {
      return MapControl.TRUE_VALUE_CLASS;
    } else if (value === MapControlValue.disabled) {
      return MapControl.DISABLED_CLASS;
    } else {
      return '';
    }
  }

  onAdd(map) {
    this.#container = document.createElement('div');
    this.#container.className = 'showhide mapboxgl-ctrl mapboxgl-ctrl-group';
    const title = this.title ? `title="${this.title}"` : '';
    const realized_class = MapControl.valueToClass(this.initialValue);
    this.#container.innerHTML = `<button id="${
      this.#widgetId
    }" class="${realized_class}" ${title}><span class="mapboxgl-ctrl-icon"></span></button>`;
    if (this.clickHandler) {
      this.#container.addEventListener('click', this.clickHandler);
    }
    return this.#container;
  }

  onRemove() {
    this.#container.parentNode.removeChild(this.#container);
  }

  static getElement(widgetSelectorId: string) {
    return document.querySelector(selectorFromId(widgetSelectorId));
  }

  static getValue(widgetSelectorId: string) {
    const element = MapControl.getElement(widgetSelectorId);
    if (element) {
      return element.classList.contains(MapControl.TRUE_VALUE_CLASS);
    } else {
      return undefined;
    }
  }

  static setValue(value, widgetSelectorId: string) {
    const element = MapControl.getElement(widgetSelectorId);
    if (element) {
      element.className = MapControl.valueToClass(
        MapControl.sanitiseValue(value),
      );
    }
  }

  static setTitle(value: string, widgetSelectorId: string) {
    const element = MapControl.getElement(widgetSelectorId);
    if (element) {
      element.setAttribute('title', value);
    }
  }
}
